var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cc-attribute-selectors"},_vm._l((_vm.attributes),function(group){return _c('attribute-selector',{key:group.id,attrs:{"group":group},on:{"selectAttribute":_vm.selectAttribute}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }